  <ion-item>
<!--    <ion-icon size="large" slot="start" name="locate"></ion-icon>-->
    <ion-checkbox aria-label="GPS" [(ngModel)]="ligado" labelPlacement="end">
      <ion-label >GPS {{ligado ? ('Precisão: '+(accuracy | number:'1.0-0') + 'm') : ''}} </ion-label>
      <ion-note  color="medium">{{point?.coordinates}}</ion-note>
    </ion-checkbox>
  </ion-item>
